import React, { ComponentType, FC } from 'react';
import { ILinkProps } from 'app/components/router/Link';
import { useNavigationContext, NavigationType } from 'app/components/header/navigation/Navigation';
import { HeaderLink } from 'app/components/header/navigation/HeaderNavigation';
import { DropdownLink } from 'app/components/header/navigation/DropdownNavigation';
import { DrawerLink } from 'app/components/header/navigation/DrawerNavigation';

export interface INavigationLinkProps extends ILinkProps {
  // Navigation link serves the purpose of styling the Link, so specifying styles is not particularly useful.
  className?: never;
  icon?: ComponentType<{ className?: string }>;
  selected?: boolean;
}

export const NavigationLink: FC<INavigationLinkProps> = props => {
  const context = useNavigationContext();
  if (!context) return null;

  switch (context.type) {
    case NavigationType.Drawer:
      return <DrawerLink {...props} />;
    case NavigationType.Dropdown:
      return <DropdownLink {...props} />;
    case NavigationType.Header:
      return <HeaderLink {...props} />;
  }
};

export default NavigationLink;
